import {Provider} from '@angular/core';

import {
  ListPersonTypesUseCaseProvider
} from '@features/setting/presentation/providers/list-person-types/list-person-types.use-case.provider';

import {ListPersonTypesFacade} from '@features/setting/presentation/facades/list-person-types/list-person-types.facade';

export const ListPersonTypesFacadeProvider: Provider[] = [
  ListPersonTypesUseCaseProvider,
  ListPersonTypesFacade
];
